/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Utilities } from '@aquila/core';
import { convertToMarkedDownString } from './FlowUtils';
import styled from 'styled-components';

const ReadMoreWrapper = styled.div({
  fontSize: 16,
  fontStyle: 'normal',
  overflow: 'hidden',
  fontFamily: 'TT Commons',
  fontWeight: 400,
  lineHeight: '24px',
  color: 'black',
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontSize: 16,
    fontStyle: 'normal',
    fontFamily: 'TT Commons',
    fontWeight: 700,
    lineHeight: '20px',
    color: 'black'
  },
  '& ul': {
    fontSize: 16,
    paddingInlineStart: 20,
    margin: 0,
    lineHeight: '24px',
    listStyleType: 'disc',
    whiteSpace: 'normal',
    '& li': {
      fontSize: 16,
      fontFamily: 'TT Commons',
      color: 'black',
      marginBottom: 5
    }
  },
  '& ol': {
    fontSize: 16,
    paddingInlineStart: 20,
    margin: 0,
    lineHeight: '24px',
    listStyleType: 'decimal',
    '& li': {
      fontSize: 16,
      fontFamily: 'TT Commons',
      color: 'black',
      marginBottom: 5,
      display: 'list-item'
    }
  },
  '& p': {
    // lineHeight: '24px'
  },
  '& p:last-child': {
    marginBottom: 0
  },
  '& p:first-child': {
    // marginTop: 0
  },
  '& a': {
    fontSize: 14,
    fontFamily: 'TT Commons',
    color: 'black',
    width: 16,
    height: 16,
    cursor: 'pointer',
    padding: 5,
    '&:hover': {
      textDecoration: 'none',
      color: '#4C406B',
      borderRadius: '50%',
      backgroundColor: '#D9D9D9'
    }
  },
  '& img': {
    width: '100%',
    marginTop: 10,
    cursor: 'pointer'
  },
  '& pre': {
    whiteSpace: 'normal'
  },
  '& table': {
    fontFamily: 'TT Commons',
    borderCollapse: 'collapse',
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
    overflowX: 'auto'
  },
  '& td': {
    border: '1px solid #dddddd',
    textAlign: 'left',
    padding: 8,
    color: 'black'
  },
  '& th': {
    border: '1px solid #dddddd',
    textAlign: 'left',
    padding: 8,
    color: 'black'
  },
  '& tr:nth-child(even)': {
    backgroundColor: 'white'
  }
});

const ReadContent = ({ summaryData }) => {
  const [newData, setNewData] = useState('');

  useEffect(() => {
    const formatData = async () => {
      const data = await Utilities.textFromContentV3(summaryData);
      const markedData = convertToMarkedDownString(data, true);
      setNewData(markedData);
    };

    formatData();
  }, [summaryData]);

  return (
    <>
      <ReadMoreWrapper dangerouslySetInnerHTML={{ __html: newData }} />
    </>
  );
};

export default ReadContent;
